import { initalizerTypes } from '../actions/initializer_actions';

export const userTypes = {
  CREATE_NEW: 'user/CREATING_NEW_USER',
  CREATE_NEW_EDIT: 'user/CREATING_NEW_USER_EDIT',
  CREATE_NEW_Temp: 'user/CREATE_NEW_Temp',
  EDIT_DATA: 'user/EDITING_USER',
  REMOVE_USER: 'user/REMOVING_USER',
  DELETE_USER: 'user/DELETE_USER',
  USER_INTEGRATION: 'user/USER_INTEGRATION',
  USER_DATAEVENTS: 'user/USER_DATAEVENTS',
  ClearUser: 'user/ClearUser',
  NewUserTotalBD: 'user/NewUserTotalBD',
  SaveLanguage: 'user/SaveLanguage',
};

const usersDefaultState = [];

export default (state = usersDefaultState, action) => {
  switch (action.type) {
    case initalizerTypes.FETCH_USERS_DATA:
      return [...action.users];
    default:
      return state;
  }
};
